import React, { useState, useMemo } from 'react';
import AgDataGrid from 'components/DataGrid/AgDataGrid';
import { ColDef } from 'ag-grid-community';

type Props = {
    rowData: any[];
    title: string;
    isGdevTable?: boolean;
    showTypeFilter?: boolean;
};

const ExcelComparisonTable: React.FC<Props> = ({ rowData, title, isGdevTable, showTypeFilter = true }) => {
    const [statusFilter, setStatusFilter] = useState('ALL');
    const [typeFilter, setTypeFilter] = useState('ALL');
    const columnDefs: ColDef[] = [
        { headerName: 'KEY', field: 'KEY', flex: 1, minWidth: 250 },
        { headerName: 'Job Number', field: 'Job Number', flex: 1 },
        { headerName: 'ID Number', field: 'ID Number', flex: 1 },
        { headerName: 'Other Number', field: 'Other Number', flex: 1 },
        { 
            headerName: isGdevTable ? 'Pole Complete' : 'Total Pole', 
            field: isGdevTable ? 'Pole Complete' : 'Total Pole', 
            flex: 1 
        },
        { 
            headerName: 'Status', 
            field: 'Status', 
            flex: 1,
            cellRenderer: (params: any) => {
                const status = params.value || '';
                const isMismatch = status.includes('Mismatch');
                const bgColor = isMismatch ? 'bg-orange-500' : 'bg-red-600';

                return (
                    <span className={`${bgColor} text-white text-xs font-bold px-2 py-1 rounded`}>
                        {status}
                    </span>
                );
            }
        },
    ];

    const filteredData = useMemo(() => {
        let data = rowData || [];
        if (statusFilter !== 'ALL') {
            data = data.filter(r => {
                const s = String(r.Status || '').toLowerCase();
                if (statusFilter === 'MISSING') return s.includes('missing');
                if (statusFilter === 'MISMATCH') return s.includes('mismatch');
                return true;
            });
        }
        if (typeFilter !== 'ALL') {
            data = data.filter(r => {
                const idNum = String(r['ID Number'] || '').toUpperCase();
                if (typeFilter === 'MRE') return idNum.includes('MRE');
                if (typeFilter === 'OCALC') return !idNum.includes('MRE');
                return true;
            });
        }
        return data;
    }, [rowData, statusFilter, typeFilter]);

    return (
        <div className="mt-3">
            <div className="flex justify-between items-center mb-2">
                <h1 className="text-lg leading-10 font-medium truncate dark:text-gray-300">
                    {title}
                </h1>
                <div className="flex space-x-2">
                    <select
                        className="text-xs border-gray-300 rounded p-1 dark:bg-gray-700 dark:text-white"
                        value={statusFilter}
                        onChange={(e) => setStatusFilter(e.target.value)}
                    >
                        <option value="ALL">ALL STATUS</option>
                        <option value="MISSING">MISSING</option>
                        <option value="MISMATCH">MISMATCH</option>
                    </select>
                    {showTypeFilter && (
                        <select
                            className="text-xs border-gray-300 rounded p-1 dark:bg-gray-700 dark:text-white"
                            value={typeFilter}
                            onChange={(e) => setTypeFilter(e.target.value)}
                        >
                            <option value="ALL">ALL TYPE</option>
                            <option value="OCALC">OCALC</option>
                            <option value="MRE">MRE</option>
                        </select>
                    )}
                </div>
            </div>
            <AgDataGrid
                columnDefs={columnDefs}
                rowData={filteredData}
                defaultPageSize={10}
                tableDimension={{
                    width: '100%',
                    height: '400px',
                }}
            />
        </div>
    );
};

export default ExcelComparisonTable;
